"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayedTransaction = void 0;
const protocol_core_1 = require("@moojo/protocol-core");
const zod_1 = require("zod");
const hex_big_int_1 = require("./hex-big-int");
exports.RelayedTransaction = zod_1.z.object({
    from: protocol_core_1.HexString,
    to: protocol_core_1.HexString,
    data: protocol_core_1.HexString,
    gas: hex_big_int_1.HexBigInt,
    deadline: zod_1.z.number(),
    signature: protocol_core_1.HexString,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVsYXllZC10cmFuc2FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWxheWVkLXRyYW5zYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHdEQUFnRDtBQUNoRCw2QkFBdUI7QUFFdkIsK0NBQXlDO0FBRTVCLFFBQUEsa0JBQWtCLEdBQUcsT0FBQyxDQUFDLE1BQU0sQ0FBQztJQUN6QyxJQUFJLEVBQUUseUJBQVM7SUFDZixFQUFFLEVBQUUseUJBQVM7SUFDYixJQUFJLEVBQUUseUJBQVM7SUFDZixHQUFHLEVBQUUsdUJBQVM7SUFDZCxRQUFRLEVBQUUsT0FBQyxDQUFDLE1BQU0sRUFBRTtJQUNwQixTQUFTLEVBQUUseUJBQVM7Q0FDckIsQ0FBQyxDQUFBIn0=